/**
 * 匠人 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const seller = {
  /** ***********普通用户BEGIN***************/
  // 列表
  list(params) {
    return axios.get(api + 'seller/list', { params: params })
  },
  // 待审列表
  reviewlist(params) {
    return axios.get(api + 'seller/reviewlist', { params: params })
  },
  // 审核
  review(params) {
    return axios.post(api + 'seller/review', qs.stringify(params))
  },
  detail(params) {
    return axios.get(api + 'seller/detail', { params: params })
  },
  remove(params) {
    return axios.post(api + 'seller/remove', qs.stringify(params))
  },
  edit(params) {
    return axios.post(api + 'seller/edit', qs.stringify(params))
  },
  //分类列表
  cate(params) {
    return axios.get(api + 'sellertype/catelist', { params: params })
  },
  //技艺列表
  skill(params) {
    return axios.get(api + 'sellertype/skilllist', { params: params })
  },
  reviewStatus(params) {
    return axios.post(api + 'seller/reviewStatus', qs.stringify(params))
  },
  exportMangheShouru(params) {
    return axios.post(api + 'export/sellermangheShouru', qs.stringify(params))
  },
  exportShouru(params) {
    return axios.post(api + 'export/sellerShouru', qs.stringify(params))
  },
  exportGoodOrder(params) {
    return axios.post(api + 'export/sellerGoodOrder', qs.stringify(params))
  },
  //有订单的供应商
  havingorderseller(params) {
    return axios.post(api + 'export/havingorderseller', qs.stringify(params))
  },
}

// 导出接口
export default seller
